import { withRouter, RouteComponentProps } from 'react-router-dom';
import * as React from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { LocationService } from "../Services/LocationService";
import ReduxStore from '../../Redux/Store/IndexStore';
import { FaChevronDown } from "react-icons/fa6";
const hiddenRoutes = [
  "/RolePermission",
  "/User",
  "/COAMaster",
  "/CustomerMaster",
  "/VendorMaster",
  "/DocumentMaster",
  "/ProductMaster",
  "/ProcessMaster",
  "/PartTemplate",
  "/WorkstationMaster",
  "/NCRCodeMaster",
  "/PriceBreakdown",
  "/Reports",
  "/SearchAll",
  "/overview",
  "/LocationMaster"
];


type Location = {
  code: string;
  name: string;
  locationId: Number,
};

type SelectOption = {
  value: string;
  label: string;
  id: Number;
};

// interface Props {
//   onChange?: (code: string) => void;
// }

interface Props extends RouteComponentProps {
  onChange?: (code: string) => void;
}


interface State {
  locations: Location[];
  selectedCode?: string;
  locationId: Number;
  requestlist?: any;
  dropdownOpen: boolean;
}

export class LocationDropdown extends React.Component<Props, State> {
  private dropdownRef = React.createRef<HTMLDivElement>();

  constructor(props: Props) {
    super(props);
    this.state = {
      locations: [],
      selectedCode: undefined,
      locationId: 0,
      dropdownOpen: false,
    };
  }

  componentDidMount() {
    this.getLocation();
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event: MouseEvent) => {
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target as Node)) {
      this.setState({ dropdownOpen: false });
    }
  };


  getLocation = () => {
    let requestlist = { ...this.state.requestlist };
    LocationService.GetLocationAll(requestlist)
      .then((result: Location[] | null) => {
        if (result && result.length > 0) {
          const storedId = Number(localStorage.getItem("locationId"));
          const matching = result.find(loc => loc.locationId === storedId);
          const selected = matching || result[0];
          if (!matching) {
            localStorage.setItem("locationId", String(selected.locationId));
              ReduxStore.dispatch({
              type: 'SET_LOCATION',
              payload: selected.locationId,
            });
          }

          
          this.setState({
            locations: result,
            selectedCode: selected.code,
            locationId: selected.locationId
          });

          if (this.props.onChange) {
            this.props.onChange(selected.code);
          }
        }
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
      });
  };

  handleLocationSelect = (location: Location) => {
    this.setState({ 
      selectedCode: location.code, 
      locationId: location.locationId,
      dropdownOpen: false 
    });
    localStorage.setItem("locationId", String(location.locationId));
    ReduxStore.dispatch({
      type: 'SET_LOCATION',
      payload: location.locationId,
    });
    if (this.props.onChange) {
      this.props.onChange(location.code);
    }
  };

  toggleDropdown = () => {
    this.setState(prevState => ({ dropdownOpen: !prevState.dropdownOpen }));
  };

  render() {
    const { location } = this.props;
    if (hiddenRoutes.includes(location.pathname)) {
      return null;
    }

    const selectedLocation = this.state.locations.find(
      (loc) => loc.locationId === this.state.locationId
    ) || this.state.locations[0];

    const displayText = selectedLocation 
      ? `${selectedLocation.name} (${selectedLocation.code})`
      : 'Select Location';

    return (
      <div className="me-2 location-menu" ref={this.dropdownRef}>
        <button 
          className="location-menu-btn"
          onClick={this.toggleDropdown}
          title="Switch Location"
        >
          <span className="location-text">{displayText}</span>
          <FaChevronDown size={16} className="chevron-icon" />
        </button>
        {this.state.dropdownOpen && (
          <div className="location-dropdown">
            <div className="dropdown-header">
              <span>Switch Location</span>
            </div>
            <div className="dropdown-divider"></div>
            {this.state.locations.map((loc) => (
              <button
                key={loc.locationId.toString()}
                className={`dropdown-item ${loc.locationId === this.state.locationId ? 'active' : ''}`}
                onClick={() => this.handleLocationSelect(loc)}
              >
                <div className="flex flex-col items-start">
                  <span>{loc.name}</span>
                  <span className="text-xs text-gray-500">({loc.code})</span>
                </div>
                {loc.locationId === this.state.locationId && (
                  <span className="text-xs text-green-600 ml-auto">Current</span>
                )}
              </button>
            ))}
          </div>
        )}
        <style>{`
          .location-menu {
            position: relative;
          }
          .location-menu-btn {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 0.5rem;
            padding: 0.5rem 0.75rem;
            border-radius: 0.5rem;
            border: 1px solid #d1d5db;
            background: #ffffff;
            cursor: pointer;
            color: #111827;
            transition: all 0.2s;
            font-size: 14px;
            width: 200px;
          }
          .location-menu-btn .location-text {
            color: #111827;
            font-weight: 500;
          }
          .location-menu-btn:hover {
            background-color: #f9fafb;
            border-color: #9ca3af;
          }
          .location-menu-btn .location-text {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            flex: 1;
          }
          .location-menu-btn .chevron-icon {
            flex-shrink: 0;
            margin-left: auto;
          }
          .location-dropdown {
            position: absolute;
            right: 0;
            margin-top: 0.5rem;
            width: 18rem;
            background-color: #ffffff;
            border-radius: 0.5rem;
            box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
            border: 1px solid #e5e7eb;
            padding: 0.5rem 0;
            z-index: 50;
          }
          .location-dropdown .dropdown-header {
            display: flex;
            align-items: center;
            gap: 0.75rem;
            padding: 0.75rem 1rem;
            font-weight: 600;
            color: #374151;
            border-bottom: 1px solid #e5e7eb;
          }
          .location-dropdown .dropdown-item {
            display: flex;
            align-items: center;
            gap: 0.75rem;
            padding: 0.75rem 1rem;
            font-size: 0.875rem;
            color: #374151;
            text-decoration: none;
            transition: background-color 0.2s;
            width: 100%;
            border: none;
            background: none;
            cursor: pointer;
            text-align: left;
            position: relative;
          }
          .location-dropdown .dropdown-item.active {
            background-color: #111827;
            color: #ffffff;
          }
          .location-dropdown .dropdown-item.active .text-gray-500 {
            color: #d1d5db;
          }
          .location-dropdown .dropdown-item:hover {
            background-color: #f9fafb;
          }
          .location-dropdown .dropdown-divider {
            border-top: 1px solid #e5e7eb;
            margin: 0.25rem 0;
          }
          .location-dropdown .flex {
            display: flex;
          }
          .location-dropdown .flex-col {
            flex-direction: column;
          }
          .location-dropdown .items-start {
            align-items: flex-start;
          }
          .location-dropdown .text-xs {
            font-size: 0.75rem;
          }
          .location-dropdown .text-gray-500 {
            color: #6b7280;
          }
          .location-dropdown .text-green-600 {
            color: #16a34a;
          }
          .location-dropdown .ml-auto {
            margin-left: auto;
          }
        `}</style>
      </div>
    );
  }
}

// export default LocationDropdown;
export default withRouter(LocationDropdown);

